import { FC, useMemo } from 'react';
import { useDispatcher } from 'hooks';
import { OrderCard } from './OrderCard';
import styles from './OrderCardList.module.css';
import { Card, Empty, Flex } from 'antd';

export const OrderCardList: FC = () => {
	const {
		dispatcherHttpClient: { isLoading },
		cardsData,
		handleCardActionClick,
	} = useDispatcher();

	const loadingCardListSkeleton = useMemo(
		() =>
			[...Array(10).keys()].map((index) => (
				<Card
					key={index}
					size='small'
					loading
					// title
				/>
			)),
		[]
	);

	// ! render
	if (isLoading)
		return (
			<Flex
				vertical
				gap='small'
				className={styles.cards_container}
			>
				{loadingCardListSkeleton}
			</Flex>
		);

	if (!cardsData.length)
		return (
			<Flex
				vertical
				gap='small'
				className={styles.cards_container}
			>
				<Empty />
			</Flex>
		);

	return (
		<Flex
			vertical
			gap='small'
			className={styles.cards_container}
		>
			{cardsData.map((card, index) => {
				return (
					<OrderCard
						key={`card-${index}`}
						card={card}
						onCardActionClick={handleCardActionClick}
					/>
				);
			})}
		</Flex>
	);
};
